import FTextBase from "components/widgets/fText/fText.client.base"
import { Component } from "vue-property-decorator"

@Component
export default class FTextWeb extends FTextBase {}
